export function useEnvironment() {
  const config = useRuntimeConfig()
  const ENVIRONMENT = config.public.ENVIRONMENT == 'preprod' ? 'production' : config.public.ENVIRONMENT
  return { ENVIRONMENT }
}
